import IePolyfills from './iePolyfills';
import LazyImage from './lazy-images';
import PubSub from './content-hub';
import RelatedContent from './related-content';
import FilterList from './filter-list';
import UrlHandler from './url-handler';
import ListsContent from './lists-content';
import GridListsContent from './grid-lists-content';
import VoyageGridItemClassUpdater from './voyage-grid-item-class-updater';
import VoyageMobileStyleHelper from './voyage-mobile-styles-helper';
import Glide from "@glidejs/glide";
import DropdownLinks from './dropdown-links';
import { removeExpandableListeners,addExpandableListeners } from './voyage-expandable-handler';
import voyageCarouselHandler from './voyage-carousel-handler';
import handleUnorthodoxGridItems from './voyage-unorthodox-list-handler';
import {addEventListeners} from './voyage-anchor-menu-handler';
import DomHelper from './helpers/dom-helper';
import ArrayHelper from './helpers/array-helper';
import IconHelper from './helpers/icon-helper';
import GUIDHelper from './helpers/guid-helper';
import DateTimeHelper from './date-time-handling';
import QueryStringHelper from './helpers/query-string-helper';
import APIHelper from './helpers/api-helper';
import ObjectHelper from './helpers/object-helper';
import DeviceHelper from './helpers/device-helper';
import LanguageSelectorHelper from './helpers/language-selector-helper';
import ElasticSearchHelper from './elastic-search-helper';
import Authors from './authors';
import populateAnchorMenuByTags from './voyage-anchor-menu-populator';
import voyageInsightsFilterTitle, { voyageInsights2FilterTitle } from './voyage-insight-filter-title';
import truncate from './helpers/truncate';
import StickyLeftNavigation from './sticky-left-navigation';
import IRScroll from './ir-scroll';
import Tabs from './tabs';
import sliderHandler from './slider-handler';
import WizardSelector from './wizard-selector';
import {voyageToughtLeaderCounterAnimation} from './voyage-tought-leader-counter-animation';

const MainOne = {
  init: function() {
    /* Polyfills */
    window.IePolyfills = new IePolyfills();

    /* Helpers */
    window.DomHelper = DomHelper;
    window.ArrayHelper = ArrayHelper;
    window.GUIDHelper = GUIDHelper;
    window.IconHelper = IconHelper;
    window.QueryStringHelper = QueryStringHelper;
    window.DateTimeHelper = DateTimeHelper;
    window.APIHelper = APIHelper;
    window.ObjectHelper = ObjectHelper;
    window.DeviceHelper = DeviceHelper;
    window.ElasticSearchHelper = ElasticSearchHelper;
    window.LanguageSelectorHelper = LanguageSelectorHelper;
    window.Authors = new Authors();

    /* Common tools */
    window.LazyImage = new LazyImage();

    /* Main components */
    window.ListsContent = new ListsContent();
    window.RelatedContent = RelatedContent;
    window.pubSubEvents = new PubSub();
    window.FilterList = new FilterList();
    window.UrlHandler = new UrlHandler();
    window.GridListsContent = new GridListsContent();
    window.VoyageGridItemClassUpdater = VoyageGridItemClassUpdater();
    window.VoyageMobileStyleHelper = VoyageMobileStyleHelper();
    window.VoyageGridItemClassUpdaterLazy = VoyageGridItemClassUpdater;
    window.Glide = Glide;
    window.DropdownLinks = DropdownLinks;
    window.removeExpandableListeners = removeExpandableListeners();
    window.addExpandableListeners= addExpandableListeners();
    window.addExpandableListenersLazy= addExpandableListeners;
    window.voyageCarouselHandler = voyageCarouselHandler();
    window.handleUnorthodoxGridItems=handleUnorthodoxGridItems();
    window.addEventListeners = addEventListeners();
    window.populateAnchorMenuByTags = populateAnchorMenuByTags();
    window.voyageInsightsFilterTitle = voyageInsightsFilterTitle;
    window.voyageInsights2FilterTitle = voyageInsights2FilterTitle;
    window.truncate = truncate;
    window.StickyLeftNavigation = StickyLeftNavigation;
    window.IRScroll = new IRScroll();
    window.Tabs = new Tabs();
    window.sliderHandler = sliderHandler();
    window.WizardSelector = WizardSelector;
    window.voyageToughtLeaderCounterAnimation = voyageToughtLeaderCounterAnimation;
  },
};

document.addEventListener(
  'DOMContentLoaded',
  () => {
    var dropdownLinks = new window.DropdownLinks();
    dropdownLinks.init();
  },
  false
)

MainOne.init();